import axios from "axios";

export const getConfig = async () => {
  const res = await axios.get(
    `https://prod-14.eastus.logic.azure.com:443/workflows/5614c73831f04bdc87c5df7440d2241d/triggers/When_a_HTTP_request_is_received/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2FWhen_a_HTTP_request_is_received%2Frun&sv=1.0&sig=v-nJk_6H8D1NtILccddw6hbOE9JLwnBawAqLlg5KgfQ`
  );
  return res.data;
};
